import { Link } from "@tanstack/react-router";
import { Facebook, Instagram, Mail, MapPin, MessageCircle } from "lucide-react";
import { WHATSAPP_NUMBER } from "@/lib/petmoon";
import { LunaStoryModal } from "./LunaStoryModal";
import logoAsset from "@/assets/petmoon-logo.png.asset.json";

export const PETMOON_EMAIL = "moonpet90@gmail.com";

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer id="contacto" className="bg-night pb-10 pt-16 text-night-foreground">
      <div className="mx-auto max-w-6xl px-5">
        <div className="grid gap-12 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <a href="#" className="flex items-center gap-2.5" aria-label="PetMoon — inicio">
              <img
                src={logoAsset.url}
                alt="Logo de PetMoon transporte de mascotas"
                className="h-11 w-11 rounded-full"
                width={44}
                height={44}
                loading="lazy"
                decoding="async"
              />

              <span className="font-display text-xl font-bold tracking-tight">PetMoon</span>
            </a>
            <p className="mt-4 max-w-sm leading-relaxed text-night-foreground/70">
              Transporte premium para perros y gatos en Zapopan , Jalisco.
              Seguro, higiénico y lleno de amor, inspirado en Luna.
            </p>
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-night-foreground/60">
              Zona de cobertura: Zapopan, Jalisco.
            </p>
            <div className="mt-5">
              <LunaStoryModal className="text-accent hover:text-night-foreground" />
            </div>
            <div className="mt-6 flex gap-3">
              <a
                href={`https://wa.me/${WHATSAPP_NUMBER}`}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp de PetMoon"
                className="flex h-11 w-11 items-center justify-center rounded-full bg-white/10 transition-colors hover:bg-accent hover:text-accent-foreground"
              >
                <MessageCircle className="h-5 w-5" aria-hidden />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram de PetMoon"
                className="flex h-11 w-11 items-center justify-center rounded-full bg-white/10 transition-colors hover:bg-accent hover:text-accent-foreground"
              >
                <Instagram className="h-5 w-5" aria-hidden />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook de PetMoon"
                className="flex h-11 w-11 items-center justify-center rounded-full bg-white/10 transition-colors hover:bg-accent hover:text-accent-foreground"
              >
                <Facebook className="h-5 w-5" aria-hidden />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-display text-sm font-bold uppercase tracking-widest text-accent">
              Contacto
            </h3>
            <ul className="mt-5 space-y-3 text-sm font-semibold text-night-foreground/80">
              <li>
                <a
                  href={`https://wa.me/${WHATSAPP_NUMBER}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 transition-colors hover:text-accent"
                >
                  <MessageCircle className="h-4 w-4" aria-hidden />
                  WhatsApp Business
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${PETMOON_EMAIL}`}
                  className="inline-flex items-center gap-2 transition-colors hover:text-accent"
                >
                  <Mail className="h-4 w-4" aria-hidden />
                  {PETMOON_EMAIL}
                </a>
              </li>
              <li>
                <Link
                  to="/seguimiento"
                  className="inline-flex items-center gap-2 transition-colors hover:text-accent"
                >
                  <MapPin className="h-4 w-4" aria-hidden />
                  Seguimiento de viaje
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-display text-sm font-bold uppercase tracking-widest text-accent">
              Legal
            </h3>
            <ul className="mt-5 space-y-3 text-sm font-semibold text-night-foreground/80">
              <li>
                <a href="#" className="transition-colors hover:text-accent">
                  Aviso de Privacidad
                </a>
              </li>
              <li>
                <a href="#" className="transition-colors hover:text-accent">
                  Términos y Condiciones
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-6 text-center text-xs font-semibold text-night-foreground/60">
          <p>
            © {year} PetMoon · Hecho{" "}
            <a
              href="https://www.mgwebserver.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-colors hover:text-accent"
            >
              MGWEB SERVER
            </a>
            {" "}con amor, inspirado por Luna 🌙
          </p>
        </div>
      </div>
    </footer>
  );
}
